import { useTranslations } from 'next-intl'
import { useUser } from '@/kmsApp/providers/user-provider'
import { titleCase } from '@/kmsApp/utils/titleCase'

export const MeComponent = ({ className }: { className?: string }) => {
  const t = useTranslations('menu_page')
  const { me, isModePrive } = useUser()

  return (
    <>
      {me && (
        <>
          <div className={className}>
            <p>
              {titleCase(me.prenom)} {titleCase(me.nom)}
            </p>
            {/* Sans ce rappel, rien ne distingue le mode privé d'un compte
                simplement sans entreprise — or le contexte change ce qui est
                facturé. */}
            {me?.entrepriseActive?.nom ? (
              <p className="text-sm">{me.entrepriseActive.nom}</p>
            ) : isModePrive ? (
              <p className="text-sm italic">{t('private_mode')}</p>
            ) : null}
          </div>
          <div
            aria-hidden="true"
            className="w-full border-t border-gray-300 dark:border-white/15 lg:mb-4"
          />
        </>
      )}
    </>
  )
}
